import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.unshift.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "select-pop"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "pop-content"
};
const _hoisted_4 = {
  key: 0,
  class: "content"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "check"
};
const _hoisted_7 = {
  class: "a-cell"
};
const _hoisted_8 = {
  class: "a-cell-left"
};
const _hoisted_9 = {
  class: "street"
};
const _hoisted_10 = {
  class: "place"
};
const _hoisted_11 = {
  key: 0,
  class: "tag"
};
const _hoisted_12 = {
  class: "info"
};
const _hoisted_13 = {
  class: "right"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["src"];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["src"];
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  key: 1,
  class: "empty"
};
const _hoisted_21 = ["src"];
import { computed, ref, onMounted, watch } from 'vue';
import { showToast } from 'vant';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useLess } from '@/models/hooks';
import constants from '@/constants';
import { Bridge } from '@/utils/bridge';
import { getAddressList as getAddressListAndInfo } from '@/utils/common';
import { rsaEncrypt } from '@/utils/encrypt';
import { useI18n } from 'vue-i18n';
import { v4 as uuidv4 } from 'uuid';
export default {
  __name: 'SelectAddressPop',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  emits: ['update:show', 'update:selected', 'close', 'confirm', 'changeAddress'],
  setup(__props, {
    expose: __expose,
    emit
  }) {
    const props = __props;
    useLess('components/SelectAddressPop.less');
    const checkedSvg = `${constants.IMAGE_URL}assets/svg/checked.svg`;
    const router = useRouter();
    const store = useStore();
    const {
      t
    } = useI18n();
    const distanceFromBottom = computed(() => {
      var _ref, _store$state$navigato;
      return (_ref = `${Number((_store$state$navigato = store.state.navigator.agentData) === null || _store$state$navigato === void 0 ? void 0 : _store$state$navigato.bottom)}px`) !== null && _ref !== void 0 ? _ref : '0';
    });
    const addressList = ref([]);
    const buttonRef = ref();
    const buttonOffsetRef = ref();
    const swipeCellDefaultWidth = computed(() => {
      var _buttonRef$value, _buttonRef$value$, _buttonOffsetRef$valu, _buttonOffsetRef$valu2;
      return ((_buttonRef$value = buttonRef.value) === null || _buttonRef$value === void 0 ? void 0 : (_buttonRef$value$ = _buttonRef$value[0]) === null || _buttonRef$value$ === void 0 ? void 0 : _buttonRef$value$.clientWidth) * 2 - ((_buttonOffsetRef$valu = buttonOffsetRef.value) === null || _buttonOffsetRef$valu === void 0 ? void 0 : (_buttonOffsetRef$valu2 = _buttonOffsetRef$valu[0]) === null || _buttonOffsetRef$valu2 === void 0 ? void 0 : _buttonOffsetRef$valu2.clientWidth);
    });
    const swipeCellWidth = computed(() => {
      var _buttonRef$value2, _buttonRef$value2$, _buttonOffsetRef$valu3, _buttonOffsetRef$valu4;
      return ((_buttonRef$value2 = buttonRef.value) === null || _buttonRef$value2 === void 0 ? void 0 : (_buttonRef$value2$ = _buttonRef$value2[0]) === null || _buttonRef$value2$ === void 0 ? void 0 : _buttonRef$value2$.clientWidth) * 3 - ((_buttonOffsetRef$valu3 = buttonOffsetRef.value) === null || _buttonOffsetRef$valu3 === void 0 ? void 0 : (_buttonOffsetRef$valu4 = _buttonOffsetRef$valu3[0]) === null || _buttonOffsetRef$valu4 === void 0 ? void 0 : _buttonOffsetRef$valu4.clientWidth) * 2;
    });
    const isLoading = ref(false);
    const showVal = computed({
      get: () => props.show,
      set: val => {
        emit('update:show', val);
      }
    });
    const cptSelected = computed({
      get: () => props.selected,
      set: val => {
        emit('update:selected', val);
      }
    });
    const setSelectedAddressInfoId = async addressInfoId => {
      Bridge.callFn('saveDataToDiskCache', {
        key: 'selectedAddressInfoId',
        value: addressInfoId,
        saveByUserId: true
      });
    };
    const getAddress = async () => {
      isLoading.value = true;
      const {
        addressList: listAddress,
        selectedAddressId
      } = await getAddressListAndInfo();
      isLoading.value = false;
      addressList.value = listAddress;
      cptSelected.value = listAddress.find(i => i.id === selectedAddressId);
    };
    const saveAddressList = list => {
      addressList.value = list;
      const encryptedAddressList = rsaEncrypt(JSON.stringify(list));
      Bridge.callFn('saveDataToDiskCache', {
        key: 'addressList',
        value: encryptedAddressList,
        saveByUserId: true
      });
    };
    const handleClick = async item => {
      emit('changeAddress', item, addressList.value);
      cptSelected.value = item;
      await setSelectedAddressInfoId(item.id);
      showVal.value = false;
    };
    const handleEdit = item => {
      router.push({
        name: 'fillAddress',
        params: {
          type: `id-${item.id}`
        }
      });
    };
    const handleDefault = item => {
      const list = addressList.value;
      list.forEach((listItem, listIndex) => {
        if (listItem.id === item.id) {
          listItem.isDefault = true;
          list.unshift(list.splice(listIndex, 1)[0]);
        } else {
          listItem.isDefault = false;
        }
      });
      saveAddressList(list);
      setSelectedAddressInfoId(item.id);
      showToast({
        message: t('modules.checkout.SET_UP_SUCCESSFULLY'),
        icon: constants.SUCCESS_ICON_IMAGE_URL,
        overlay: false,
        overlayClass: 'a-overlay-white',
        className: 'a-toast'
      });
      store.commit('checkout/setAddressChange', uuidv4());
    };
    watch(() => store.state.checkout.addressChange, val => {
      if (val && !showVal.value) {
        getAddress();
      }
    });
    const handleDelete = item => {
      const list = addressList.value;
      const currentIndex = list.findIndex(i => item.id === i.id);
      list.splice(currentIndex, 1);
      saveAddressList(list);
      if (item.id === props.selected.id) {
        const selectedVal = list.length > 0 ? list[0] : null;
        emit('changeAddress', selectedVal, addressList.value);
        store.commit('checkout/setFillAddress', selectedVal);
        cptSelected.value = selectedVal;
      }
      showToast({
        message: t('modules.checkout.DELETE_SUCCESSFULLY'),
        icon: constants.SUCCESS_ICON_IMAGE_URL,
        overlay: false,
        overlayClass: 'a-overlay-white',
        className: 'a-toast'
      });
      store.commit('checkout/setAddressChange', uuidv4());
    };
    const handleAdd = () => {
      emit('update:show', false);
      router.push({
        name: 'fillAddress',
        params: {
          type: 'back'
        }
      });
    };
    onMounted(() => {
      getAddress();
    });
    __expose({
      getAddress
    });
    return (_ctx, _cache) => {
      const _component_van_swipe_cell = _resolveComponent("van-swipe-cell");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_popup = _resolveComponent("van-popup");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_van_popup, {
        show: showVal.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => showVal.value = $event),
        closeable: "",
        round: "",
        position: "bottom",
        "overlay-class": "a-overlay-white",
        class: "a-select-pop",
        style: {
          height: '410px',
          width: '100%'
        }
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('modules.checkout.SELECT_SHIPPING_ADDRESS')), 1), _createElementVNode("div", _hoisted_3, [addressList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addressList.value, item => {
          return _openBlock(), _createBlock(_component_van_swipe_cell, {
            class: "a-swipe-cell",
            key: item.id,
            "right-width": item.isDefault ? swipeCellDefaultWidth.value : swipeCellWidth.value
          }, {
            right: _withCtx(() => [_createElementVNode("div", _hoisted_13, [!item.isDefault ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "a-button default",
              onClick: $event => handleDefault(item)
            }, [_createElementVNode("img", {
              src: `${_unref(constants).IMAGE_URL}assets/svg/backTop.svg`,
              alt: ""
            }, null, 8, _hoisted_15), _createElementVNode("span", null, _toDisplayString(_unref(t)('modules.checkout.SET_AS_DEFAULT')), 1)], 8, _hoisted_14)) : _createCommentVNode("", true), _createElementVNode("div", {
              class: "a-button edit",
              onClick: $event => handleEdit(item),
              ref_for: true,
              ref_key: "buttonRef",
              ref: buttonRef
            }, [_createElementVNode("img", {
              src: `${_unref(constants).IMAGE_URL}assets/svg/edit.svg`,
              alt: ""
            }, null, 8, _hoisted_17), _createElementVNode("span", null, _toDisplayString(_unref(t)('button.EDIT')), 1)], 8, _hoisted_16), _createElementVNode("div", {
              class: "a-button delete",
              onClick: $event => handleDelete(item)
            }, [_createElementVNode("img", {
              src: `${_unref(constants).IMAGE_URL}assets/svg/delete.svg`,
              alt: ""
            }, null, 8, _hoisted_19), _createElementVNode("span", null, _toDisplayString(_unref(t)('button.DELETE')), 1)], 8, _hoisted_18), _createElementVNode("div", {
              class: "buttonOffset",
              ref_for: true,
              ref_key: "buttonOffsetRef",
              ref: buttonOffsetRef
            }, null, 512)])]),
            default: _withCtx(() => {
              var _props$selected;
              return [_createElementVNode("div", {
                class: "cell-content",
                onClick: $event => handleClick(item)
              }, [_createElementVNode("div", _hoisted_6, [((_props$selected = __props.selected) === null || _props$selected === void 0 ? void 0 : _props$selected.id) == item.id ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: checkedSvg,
                alt: ""
              })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.state) + _toDisplayString(item.city) + _toDisplayString(item.district), 1), _createElementVNode("div", _hoisted_10, [item.isDefault ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(t)('modules.checkout.DEFAULT')), 1)) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(item.address), 1)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", null, _toDisplayString(item.name), 1), _createTextVNode(), _createElementVNode("span", null, _toDisplayString(item.phone), 1)])])])], 8, _hoisted_5)];
            }),
            _: 2
          }, 1032, ["right-width"]);
        }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("img", {
          src: `${_unref(constants).IMAGE_URL}assets/image/notAddress.png`,
          alt: ""
        }, null, 8, _hoisted_21), _createElementVNode("div", null, _toDisplayString(_unref(t)('modules.checkout.NO_SHIPPING_ADDRESS')), 1)]))]), _createElementVNode("div", {
          class: "btn-box",
          style: _normalizeStyle({
            paddingBottom: distanceFromBottom.value
          })
        }, [_createVNode(_component_van_button, {
          round: "",
          class: "add-address",
          color: "#EB1745",
          block: "",
          onClick: handleAdd
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('modules.checkout.ADD_SHIPPING_ADDRESS')), 1)]),
          _: 1
        })], 4)])), [[_directive_loading, isLoading.value]])]),
        _: 1
      }, 8, ["show"]);
    };
  }
};